module.exports = __webpack_public_path__ + "static/RootSans-12BlackItalic-8f10358eeedc325eb39c58d6456d6843.woff2";